import { Context } from "./cond";

/**
 * 断言函数，用于根据上下文计算一个数值
 */
export type Predicate = (context: Context) => number;

// 自身

/**
 * 自身最大体力的x分之一：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 自身最大体力的x分之一(x: number): Predicate {
    return ({ sbjPet }: Context) => {
        return Math.floor(sbjPet.最大体力 / x);    
    }
}

/**
 * 自身最大体力的百分之x：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 自身最大体力的百分之x(x: number): Predicate {
    return ({ sbjPet }: Context) => {
        return Math.floor(sbjPet.最大体力 * x / 100);
    }
}

/**
 * 自身特攻和速度总和的百分之x：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 自身特攻和速度总和的百分之x(x: number): Predicate {
    return ({ sbjPet }: Context) => {
        return Math.floor((sbjPet.能力值.特攻 + sbjPet.能力值.速度) * x / 100);
    }
}

// 对手

/**
 * 对手最大体力的x分之一：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 对手最大体力的x分之一(x: number): Predicate {
    return ({ objPet }: Context) => {
        return Math.floor(objPet.最大体力 / x);
    }
}

/**
 * 对手最大体力的百分之x：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 对手最大体力的百分之x(x: number): Predicate {
    return ({ objPet }: Context) => {
        return Math.floor(objPet.最大体力 * x / 100);
    }
}

/**
 * 对手防御特防总和的百分之x：执行对应的领域操作。
 * @param x x参数，参与本次操作
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function 对手防御特防总和的百分之x(x: number): Predicate {
    return ({ objPet }: Context) => {
        return Math.floor((objPet.能力值.特防 + objPet.能力值.防御) * x / 100);
    }
}